import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';

const SingleDayView = ({ day, schedules, subjects, teachers, rooms, grades, timeSlots, handleOpenModal, isEditor, darkGrayCellStyle }) => {
  const exportGrades = [7, 8, 9, 10, 11, 12];
  
  const getEventsForDay = (grade, timeSlotId) => {
    const year = day.getFullYear();
    const month = String(day.getMonth() + 1).padStart(2, '0');
    const date = String(day.getDate()).padStart(2, '0');
    const dayString = `${year}-${month}-${date}`;
    return schedules.filter(event => event.day === dayString && event.grade === grade && event.timeSlotId === timeSlotId);
  };

  return (
    <Box id="single-day-table" sx={{ p: 1, bgcolor: 'white' }}>
      <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed', minWidth: '1200px' }}>
        <thead>
          <tr>
            <th style={{...darkGrayCellStyle, width: '100px', whiteSpace: 'nowrap', fontSize: '12px'}}>Time</th>
            {exportGrades.map(grade => <th key={grade} style={{...darkGrayCellStyle, textAlign: 'center', width: '180px', fontSize: '14px'}}>{`Grade ${grade}`}</th>)}
          </tr>
        </thead>
        <tbody>
          {timeSlots.map(timeSlot => {
            const isSpecialRow = ['snack', 'lunch', 10].includes(timeSlot.id);
            const rowStyle = { backgroundColor: isSpecialRow ? '#f5f5f5' : 'inherit' };
            return (
              <tr key={timeSlot.id}>
                <td style={{...darkGrayCellStyle, ...rowStyle, width: '100px', whiteSpace: 'nowrap', fontSize: '11px'}}>{timeSlot.time}</td>
                {exportGrades.map(grade => {
                  const events = getEventsForDay(grade, timeSlot.id);
                  let cellContent;
                  if (events.length > 1) {
                    cellContent = (
                      <Box sx={{ display: 'flex', gap: '2px', width: '100%', height: '100%' }}>
                        {events.map(event => {
                          const subject = event.customSubject ? { name: event.customSubject } : subjects.find(s => s._id === event.subjectId);
                          const teacher = event.customTeacher ? { name: event.customTeacher } : teachers.find(t => t._id === event.teacherId);
                          const room = event.customRoom ? { name: event.customRoom } : rooms.find(r => r._id === event.roomId);
                          const eventColor = event.color || (subject && subject.color ? subject.color : '#808080');
                          return (
                            <Box key={event._id} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', flex: 1, backgroundColor: eventColor, color: 'white', padding: '2px 4px', paddingRight: event.isOnline ? '18px' : '4px', borderRadius: '2px', fontSize: '0.7rem', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'left' }}>
                              <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold', lineHeight: 1.1 }}>{subject ? subject.name : 'Event'}</Typography>
                              <Typography sx={{ fontSize: '0.65rem', lineHeight: 1.1 }}>{teacher ? teacher.name : 'N/A'} / {room ? room.name : 'N/A'}</Typography>
                              {event.isExam && (
                                <Box sx={{ mt: 'auto', alignSelf: 'flex-start', padding: '0 4px', height: 14, borderRadius: '2px', bgcolor: '#e60000', border: '1px solid #ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <Typography sx={{ fontSize: '0.5rem', fontWeight: 900, color: '#ffffff', letterSpacing: '0.5px', lineHeight: 1 }}>EXAM</Typography>
                                </Box>
                              )}
                              {event.isOnline && (
                                <Box sx={{ position: 'absolute', bottom: 2, right: 2, width: 14, height: 14, borderRadius: '50%', bgcolor: 'rgba(0,0,0,0.28)', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                                  <WifiIcon sx={{ fontSize: '0.65rem', color: '#ffffff' }} />
                                </Box>
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  } else if (events.length === 1) {
                    const event = events[0];
                    const subject = event.customSubject ? { name: event.customSubject } : subjects.find(s => s._id === event.subjectId);
                    const teacher = event.customTeacher ? { name: event.customTeacher } : teachers.find(t => t._id === event.teacherId);
                    const room = event.customRoom ? { name: event.customRoom } : rooms.find(r => r._id === event.roomId);
                    const eventColor = event.color || (subject && subject.color ? subject.color : '#808080');
                    cellContent = (
                      <Box key={event._id} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', backgroundColor: eventColor, color: 'white', padding: '4px 6px', paddingRight: event.isOnline ? '20px' : '6px', borderRadius: '2px', fontSize: '0.75rem', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'left', minHeight: '100%' }}>
                        <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', lineHeight: 1.2 }}>{subject ? subject.name : 'Event'}</Typography>
                        <Typography sx={{ fontSize: '0.7rem', lineHeight: 1.2 }}>{teacher ? teacher.name : 'N/A'} / {room ? room.name : 'N/A'}</Typography>
                        {event.isExam && (
                          <Box sx={{ mt: 'auto', alignSelf: 'flex-start', padding: '0 4px', height: 16, borderRadius: '2px', bgcolor: '#e60000', border: '1px solid #ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography sx={{ fontSize: '0.55rem', fontWeight: 900, color: '#ffffff', letterSpacing: '0.5px', lineHeight: 1 }}>EXAM</Typography>
                          </Box>
                        )}
                        {event.isOnline && (
                          <Box sx={{ position: 'absolute', bottom: 3, right: 3, width: 16, height: 16, borderRadius: '50%', bgcolor: 'rgba(0,0,0,0.28)', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                            <WifiIcon sx={{ fontSize: '0.7rem', color: '#ffffff' }} />
                          </Box>
                        )}
                      </Box>
                    );
                  } else {
                    if (timeSlot.id === 'snack') { cellContent = <Typography sx={{fontWeight: 'bold', color: 'black', textAlign: 'center', fontSize: '0.8rem'}}>Snack</Typography>; }
                    else if (timeSlot.id === 'lunch') { cellContent = <Typography sx={{fontWeight: 'bold', color: 'black', textAlign: 'center', fontSize: '0.8rem'}}>Lunchbreak</Typography>; }
                    else if (timeSlot.id === 10) { cellContent = <Typography sx={{fontWeight: 'bold', color: 'black', textAlign: 'center', fontSize: '0.8rem'}}>Homework Time</Typography>; }
                  }
                  return (<td key={`${grade}-${timeSlot.id}`} style={{...darkGrayCellStyle, ...rowStyle, padding: '2px'}}>{cellContent}</td>);
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </Box>
  );
};

export default SingleDayView;
